import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'JAP',
    tagline: "Grupi i vullnetarëve përmirësues të shoqërisë",
    description: "JAP-i është bashkim vullnetar, anëtarët e të cilit japin nga koha, aftësitë, përvoja dhe pasuria e tyre për të mirën e përgjithshme.",
    url: getOrigin(),
    ogImage: 'https://jap.cdn.modulify.website/dokumente/jap-broshura-2024-kopertina.png',
    email: 'bashke@jap-i.com',
    brochureUrl: 'https://jap.cdn.modulify.website/dokumente/jap-broshura-2024.pdf'
}

export const navigation = [
    { label: "Manifesti", href: '#manifesti' },
    { label: "Projektet", href: '#projektet' },
    { label: "Fakte", href: '#fakte' },
    { label: "Broshura", href: '#broshura' }
]
